import { useTheme } from '@/components/ThemeProvider';
import { SortIcon } from '@/widget/Icon';
import { useTranslation } from 'react-i18next';
import { SortTypeEnum } from '@/request/request.enum';
import { useMemo } from 'react';
import { SortConfig } from '../../..';

interface IProps {
  handleSort: (key: SortConfig['key']) => void;
  getSortStatus: (key: SortConfig['key']) => SortTypeEnum;
}
export default (props: IProps) => {
  const { handleSort, getSortStatus } = props;
  const { t } = useTranslation();
  const { theme } = useTheme();

  const buttonGroups = useMemo(
    () => [
      [
        { key: 'vol', label: t('Token.vol'), hasSlash: false },
        { key: 'mc', label: t('Token.mc'), hasSlash: true },
      ],
      [
        { key: 'price', label: t('Token.price'), hasSlash: false },
        { key: 'time', label: t('Token.chg'), hasSlash: true, suffix: '%' },
      ],
    ],
    [t],
  );
  return (
    <div className="h-[32px] flex items-center justify-between text-[12px] font-[400] text-secondaryTextColor bg-primaryBgColor z-10 sticky top-0 left-0 right-0">
      {buttonGroups.map((group, groupIndex) => (
        <div key={groupIndex} className="flex items-center">
          {group.map(({ key, label, hasSlash, suffix }) => (
            <button key={key} onClick={() => handleSort(key as SortConfig['key'])} className="flex items-center ">
              {hasSlash && <span>/</span>}
              <span>
                {label}
                {suffix}
              </span>
              <SortIcon theme={theme} status={getSortStatus(key as SortConfig['key'])} className="w-[16px] h-[16px]" />
            </button>
          ))}
        </div>
      ))}
    </div>
  );
};
